
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface PractitionerAboutProps {
  bio?: string;
}

const PractitionerAbout: React.FC<PractitionerAboutProps> = ({ bio }) => {
  if (!bio) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>About</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-earth-700 leading-relaxed">{bio}</p>
      </CardContent>
    </Card>
  );
};

export default PractitionerAbout;
